
// import { useEffect } from "react";
import "./App.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from './Components/ScrollToTop';
import { BrowserRouter as Router, Routes, Route,Navigate } from "react-router-dom";
import { SignupProvider } from './context/SignupContext';
import { LoginProvider } from './context/LoginContext.js';
import { MessageProvider } from './context/MessageContext.js';
import Home from './Components/home/index.js'
import LayoutWithHeaderFooter from './Components/LayoutHeadFoot.js'
// import SignupComponent from './Components/pages/register/CreateAccount.js'
import SignupPage from './Components/pages/register/SignupPage.js'
import VerifyAccount from './Components/pages/register/VerifyAccount.js'
import SuccessPage from './Components/pages/register/SuccessPage.js'
import CreateProfile from './Components/pages/register/CreateProfile.js'
import EditProfile from './Components/pages/register/EditProfile.js'
import LoginPage from './Components/pages/register/LoginPage.js'
import ForgotPassword from './Components/pages/register/ForgotPassword.js'
// import ResetEmail from './Components/pages/register/ResetEmail.js'
// import ResetEmaResetPasswordil from './Components/pages/register/ResetPassword.js'
import FilterCardGallery from './Components/profiles/recently-joined-members/index.js'
import SearchById from './Components/profiles/search-by-id/index.js'
// import CustomSearch from './Components/profiles/custom-search/index.js'
import ProfilePage from './Components/profiles/others-profiles/index.js'
import Upgrade from './Components/profiles/upgrade/index.js'
import PaymentStatus from './Components/profiles/paymentstatus/index.js'
import PaymentPlan from './Components/profiles/paymentplan/index.js'
import AddPhotos from './Components/profiles/add-photos/index.js'
// import MyProfilePage from './Components/profiles/my-profile/index.js'
import Search from './Components/profiles/search/index.js'
import Contact from './Components/profiles/contact/index.js'
import ReportMisuseForm from './Components/profiles/report/index.js'
// import PartnerSearch from './Components/profiles/search-partner/index.js'
// import SearchPartnerById from './Components/profiles/search-partner-id'
// import EditProfileForm from './Components/profiles/edit-your-profile/index.js'
import ChatApp from './Components/profiles/Chat-ui/index.js'
// import Notifications from './Components/profiles/Notification/index.js'
import PrivacyPolicy from './Components/profiles/Policy/Privacy/index.js'
import TermsOfUse from './Components/profiles/Policy/Terms-of-use/index.js'
import HowToUse from './Components/profiles/Policy/How-to-use/index.js'
import ReturnRefund from './Components/profiles/Policy/return/index.js'
// import Links from './links-delete/Links.js'
import BlogPage from './Components/profiles/Blog/index.js'
import BlogDetail from './Components/profiles/blog-post/index.js'
import PricingPlanCard from './Components/profiles/pricing/index.js'
import CityTesting from './Components/home/CityTesting.js'
import OTP from './Components/pages/register/otp.js'
import SendOtp from './Components/pages/register/sendotp.js'
import DesiredPartner from "./Components/profiles/desired-partner/DesiredPartner.js"
import EditPartner from "./Components/profiles/desired-partner/EditPartner.js"
import ProfileSuccess from "./Components/profiles/profile-succees/ProfileSuccess.js"
import Thank from "./Components/profiles/contact/Thank.js";

function App() {
  return (
    <LoginProvider>
      <SignupProvider>
        <MessageProvider>
          <Router>
            <ScrollToTop />
            {/* <Header/> */}
            <Routes>
              <Route path="/" element={
                <LayoutWithHeaderFooter>
                  <Home />
                </LayoutWithHeaderFooter>
              } />

              {/* <Route path="/create-account/" element={<SignupComponent />} /> */}
              <Route path="/sign-up/" element={ <LayoutWithHeaderFooter>
                <SignupPage /></LayoutWithHeaderFooter> } />
              <Route path="/verify-account/" element={<VerifyAccount />} />
              <Route path="/success/" element={<SuccessPage />} />
              <Route path="/create-profile/" element={<LayoutWithHeaderFooter><CreateProfile /></LayoutWithHeaderFooter>} />
              <Route path="/edit-profile/:id" element={<EditProfile />} />
              <Route path="/edit-partner/:id" element={<EditPartner />} />
              <Route path="/login/" element={ <LayoutWithHeaderFooter>
                <LoginPage /> </LayoutWithHeaderFooter> } />
              <Route path="/fogot-password/" element={<LayoutWithHeaderFooter>
                <ForgotPassword /></LayoutWithHeaderFooter>} />
              {/* <Route path="/reset-email/" element={<ResetEmail />} /> */}
              {/* <Route path="/reset-password/" element={<ResetEmaResetPasswordil />} /> */}
              <Route path="/recently-joined-matches/" element={<FilterCardGallery />} />
              <Route path="/search-id" element={<SearchById />} />
              {/* <Route path="/custom-search" element={<CustomSearch />} /> */}
              <Route path="/view-profile/:id" element={<ProfilePage />} />
              <Route path="/upgrade/:id" element={<Upgrade />} />
              <Route path="/paymentstatus/:id" element={<PaymentStatus />} />
              <Route path="/plan/:id" element={<PaymentPlan />} />
              <Route path="/profile-picture/:id" element={<AddPhotos />} />
              {/* <Route path="/my-profile" element={<MyProfilePage />} /> */}
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/report-misuse-form" element={<ReportMisuseForm />} />
              <Route path="/search" element={<Search />} />
              {/* <Route path="/search-partner" element={<PartnerSearch />} /> */}
              {/* <Route path="/search-partner-id" element={<SearchPartnerById />} /> */}
              {/* <Route path="/edit-profile-form" element={<EditProfileForm />} /> */}
              <Route path="/chat" element={<ChatApp />} />
              <Route path="/chat/:id" element={<ChatApp />} />
              {/* <Route path="/notifications" element={<Notifications />} /> */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/terms-conditions" element={<HowToUse />} />
              <Route path="/return-refund" element={<ReturnRefund />} />
              {/* <Route path="/links" element={<Links />} /> */}
              {/* <Route path="blog" element={ <BlogPage/>  } />
    <Route path="blog-post" element={ <BlogDetail/>  } /> */}
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/thankyou" element={<Thank />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/pricing" element={<PricingPlanCard />} />
              <Route path="/city-testing" element={<CityTesting />} />
              <Route path="/otp" element={ <LayoutWithHeaderFooter>  <OTP/> </LayoutWithHeaderFooter>} />
              <Route path="/send-otp" element={<LayoutWithHeaderFooter> <SendOtp /></LayoutWithHeaderFooter>} />
              <Route path="/profile-success" element={<ProfileSuccess />} />
              <Route path="/desired-partner" element={<LayoutWithHeaderFooter><DesiredPartner /></LayoutWithHeaderFooter>} />

              {/* Catch-all route for 404s - redirects to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            {/* <Footer/> */}
          </Router>
        </MessageProvider>
      </SignupProvider>
    </LoginProvider>
  );
}

export default App;
